import {
  IMediaType,
  ICreateMediaTypeAction,
  IGetMediaTypeByIdAction,
  IGetMediaTypeByIdSuccessAction,
  IFailureAction,
  IUpdateMediaTypeAction,
  IUpdateMediaTypeSuccessAction,
  IDeleteMediaTypeAction,
  IDeleteMediaTypeSuccessAction,
  ICreateMediaTypeSuccessAction,
} from '../types/mediaType'
import { types } from '../types/mediaType'

export const createMediaType = (
  mediaTypeData: IMediaType
): ICreateMediaTypeAction => ({
  type: types.CREATE_MEDIA_TYPE__STARTED,
  mediaTypeData,
})

export const createMediaTypeSuccess = (
  mediaTypeData: IMediaType,
  message: string
): ICreateMediaTypeSuccessAction => ({
  type: types.CREATE_MEDIA_TYPE__SUCCESS,
  mediaTypeData,
  message,
})

export const createMediaTypeFailure = (message: string): IFailureAction => ({
  type: types.CREATE_MEDIA_TYPE__FAILURE,
  message,
})

export const getMediaTypeById = (
  extension: string
): IGetMediaTypeByIdAction => ({
  type: types.GET_MEDIA_TYPE_BY_ID__STARTED,
  extension,
})

export const getMediaTypeByIdSuccess = (
  mediaTypeData: IMediaType
): IGetMediaTypeByIdSuccessAction => ({
  type: types.GET_MEDIA_TYPE_BY_ID__SUCCESS,
  mediaTypeData,
})

export const getMediaTypeByIdFailure = (message: string): IFailureAction => ({
  type: types.GET_MEDIA_TYPE_BY_ID__FAILURE,
  message,
})

export const updateMediaType = (
  mediaTypeData: IMediaType
): IUpdateMediaTypeAction => ({
  type: types.UPDATE_MEDIA_TYPE__STARTED,
  mediaTypeData,
})

export const updateMediaTypeSuccess = (
  mediaTypeData: IMediaType,
  message: string
): IUpdateMediaTypeSuccessAction => ({
  type: types.UPDATE_MEDIA_TYPE__SUCCESS,
  mediaTypeData,
  message,
})

export const deleteMediaType = (extension: string): IDeleteMediaTypeAction => ({
  type: types.DELETE_MEDIA_TYPE__STARTED,
  extension,
})

export const deleteMediaTypeSuccess = (
  message: string
): IDeleteMediaTypeSuccessAction => ({
  type: types.DELETE_MEDIA_TYPE__SUCCESS,
  message,
})

export const deleteMediaTypeFailure = (message: string): IFailureAction => ({
  type: types.DELETE_MEDIA_TYPE__FAILURE,
  message,
})

export const updateMediaTypeFailure = (message: string): IFailureAction => ({
  type: types.UPDATE_MEDIA_TYPE__FAILURE,
  message,
})
